module.exports = __webpack_public_path__ + "img/bigcar-out.261aa608.png";